import { h } from "preact";
import { observer } from "mobx-react";
function ItemCountBadge({ count, variant }) {
    if (count === 0)
        return null;
    let badgeVariantClass = "";
    switch (variant) {
        case "default":
            badgeVariantClass = "m-badge--default";
            break;
        case "primary-text":
            badgeVariantClass = "m-badge--primary-text";
            break;
        case "primary-bg":
            badgeVariantClass = "m-badge--primary-bg";
            break;
        case "secondary":
            badgeVariantClass = "m-badge--secondary-text";
            break;
    }
    return (h("span", { class: `m-badge m-badge--rounded ${badgeVariantClass}` }, count));
}
export default observer(ItemCountBadge);
